import React, {Component} from 'react'
import PropTypes from 'prop-types'
import HistoryTable from "./HistoryTable"
import {getHistory} from "../../../../services/api/apiSku"
import PubSub from 'pubsub-js'

class HistoryPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            error: '',
            listHistory: []
        }
    }

    _subscription = null

    componentDidMount() {
        this._fetchListHistory()
        this._subscription = PubSub.subscribe('GET_HISTORY', this._fetchListHistory)
    }

    _fetchListHistory = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {id} = this.props

            const {data: responsive} = await getHistory(id)

            const {data, success, error} = responsive

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                listHistory: data.items
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {loading, error, listHistory} = this.state

        return (
            <div className='HistoryPage mt-3'>
                <h3 className='font-weight-bold'>Item histories</h3>
                <HistoryTable loading={loading} error={error} listHistories={listHistory}/>
            </div>
        )
    }
}

HistoryPage.propTypes = {
    id: PropTypes.string
}

export default HistoryPage